/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/paperclip'
export default icon
